import React, { useState } from "react";
import "./login.css";
import { supabase } from "../../supabaseClient"; // Import your Supabase client

import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import NarrowInputField from "../../components/input/new/narrowInputField";
import NarrowPasswordField from "../../components/input/new/narrowPasswordField";
import DeterminateProgress from "../../components/input/new/determinateProgress";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = () => {
    navigate("/grow/reset-password");
  };

  const handleContinue = async (email, password) => {
    try {
      // Use Supabase's auth.signInWithPassword to log in with the email and password
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        console.error("Error logging in:", error.message);
        alert("Failed to log in. Please check your credentials.");
      } else {
        // alert('Logged in successfully!');
        navigate("/grow/set-goals", { state: data });
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <div>
      <SignupToolbar onlyHelp={true} />
      <div className="login-container">
        <div className="main-content">
          <div className="card-login">
            <h2 className="login-title">Log in</h2>

            <NarrowInputField
              title="Email"
              placeholder="Enter your email"
              isRequired={true}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <NarrowPasswordField
              title="Password"
              placeholder="Enter your password"
              isRequired={true}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {/* Heading */}
            <div style={{ marginTop: "20px" }}>
              <p onClick={handleForgotPassword} className="forgot-password">
                Forgot your password?
              </p>
            </div>
          </div>
        </div>

        {/* Bottom navigation bar */}
        <DeterminateProgress value={60} />
        <div className="bottom-bar">
          <div className="bottom-bar-left">
            <span className="section-label">Log in</span>
            <span className="step-indicator">Step 3 of 5</span>
          </div>
          <button
            type="button"
            className="continue-btn-login"
            onClick={() => handleContinue(email, password)}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
